/** Signup / registration page content — frontend-only for /signup */

import { pageRoute, appRoute } from "./paths.js";

export const signupPage = {
  documentTitle: "Taldel — Sign up",
  hero: {
    titleSegments: [
      { text: "Create ", highlight: null },
      { text: "your", highlight: "primary" },
      { text: " Taldel ", highlight: null },
      { text: "account", highlight: "secondary" },
      { text: ".", highlight: null },
    ],
    subtitle:
      "Choose how you work with Taldel — as a client, a team, or an individual — then finish a short registration. Frontend-only for now; no account is created on a server yet.",
  },
  form: {
    submitLabel: "Create account",
    accountTypes: [
      {
        id: "client",
        label: "Client",
        description: "Companies hiring Taldel to design, build, or scale product.",
      },
      {
        id: "team",
        label: "Team",
        description: "Squads that want a shared workspace and delivery rhythm.",
      },
      {
        id: "individual",
        label: "Individual",
        description: "Engineers, designers, and operators joining on their own.",
      },
    ],
    sharedFields: [
      {
        name: "fullName",
        type: "text",
        placeholder: "Full name",
        autocomplete: "name",
        required: true,
      },
      {
        name: "email",
        type: "email",
        placeholder: "Work email",
        autocomplete: "email",
        required: true,
      },
      {
        name: "password",
        type: "password",
        placeholder: "Password",
        autocomplete: "new-password",
        required: true,
        minlength: 8,
      },
      {
        name: "confirmPassword",
        type: "password",
        placeholder: "Confirm password",
        autocomplete: "new-password",
        required: true,
        minlength: 8,
      },
    ],
    typeFields: {
      client: [
        {
          name: "companyName",
          type: "text",
          placeholder: "Company name",
          autocomplete: "organization",
          required: true,
        },
        {
          name: "jobTitle",
          type: "text",
          placeholder: "Job title",
          autocomplete: "organization-title",
          required: true,
        },
        {
          name: "companySize",
          type: "select",
          placeholder: "Company size",
          required: true,
          options: [
            { value: "", label: "Company size", disabled: true },
            { value: "1-10", label: "1–10" },
            { value: "11-50", label: "11–50" },
            { value: "51-200", label: "51–200" },
            { value: "201+", label: "201+" },
          ],
        },
      ],
      team: [
        {
          name: "teamName",
          type: "text",
          placeholder: "Team name",
          required: true,
        },
        {
          name: "teamSize",
          type: "select",
          placeholder: "Team size",
          required: true,
          options: [
            { value: "", label: "Team size", disabled: true },
            { value: "2-5", label: "2–5" },
            { value: "6-12", label: "6–12" },
            { value: "13-30", label: "13–30" },
            { value: "31+", label: "31+" },
          ],
        },
        {
          name: "teamRole",
          type: "text",
          placeholder: "Your role on the team",
          required: true,
        },
      ],
      individual: [
        {
          name: "professionalTitle",
          type: "text",
          placeholder: "Professional title",
          required: true,
        },
        {
          name: "focusArea",
          type: "select",
          placeholder: "Focus area",
          required: true,
          options: [
            { value: "", label: "Focus area", disabled: true },
            { value: "engineering", label: "Engineering" },
            { value: "design", label: "Design" },
            { value: "product", label: "Product" },
            { value: "data-ai", label: "Data / AI" },
            { value: "other", label: "Other" },
          ],
        },
      ],
    },
  },
  success: {
    kicker: "Thank you",
    title: "We have received your details",
    body: "Someone from our team will reach out.",
    primaryLabel: "Back to home",
    primaryHref: appRoute("hero"),
    secondaryLabel: "Browse Our Portfolios",
    secondaryHref: pageRoute("our-portfolios"),
  },
};

export function getSignupPage() {
  return signupPage;
}

export function signupRoute(section = "") {
  return pageRoute("signup", section);
}
